var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 164,
    viewBox: "0 0 200 203",
    fill: "none",
    "data-sentry-element": "svg",
    "data-sentry-source-file": "ProductsNotFound.jsx",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50077 171.398C11.1168 189.983 23.5348 193.851 32.2656 189.983C49.1507 182.501 93.0123 174.143 138.06 193.791C197.723 219.814 210.417 180.552 191.376 140.837C172.334 101.123 165.88 60.9603 187.831 38.8331C209.782 16.706 181.057 -17.9088 130.044 18.1228C97.0779 41.4077 72.8843 36.2229 59.8925 29.6403C47.6481 23.4365 34.0308 16.9507 21.2728 22.0148C5.79229 28.1598 -0.30751 41.4825 23.2454 71.2455C56.6218 113.422 -13.5715 129.74 3.50077 171.398Z",
    fill: "#DEE9FF",
    "data-sentry-element": "path",
    "data-sentry-source-file": "ProductsNotFound.jsx"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5107 80.8643H153.039V172.02C153.039 172.205 152.965 172.383 152.834 172.515C152.703 172.646 152.525 172.72 152.339 172.72H35.2107C35.0251 172.72 34.847 172.646 34.7158 172.515C34.5845 172.383 34.5107 172.205 34.5107 172.02V80.8643Z",
    fill: "#87AAFF",
    "data-sentry-element": "path",
    "data-sentry-source-file": "ProductsNotFound.jsx"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.304 45.1428H68.191L34.5107 80.8642H153.039L123.304 45.1428Z",
    fill: "#1E5EFF",
    "data-sentry-element": "path",
    "data-sentry-source-file": "ProductsNotFound.jsx"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7373 30.8541L68.1907 45.1427L34.5105 80.8642L8.99512 61.4725L45.7373 30.8541Z",
    fill: "#699CFF",
    "data-sentry-element": "path",
    "data-sentry-source-file": "ProductsNotFound.jsx"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.757 30.8541L123.304 45.1427L153.039 80.8642L182.499 61.4725L145.757 30.8541Z",
    fill: "#699CFF",
    "data-sentry-element": "path",
    "data-sentry-source-file": "ProductsNotFound.jsx"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6703 31.5847C83.3039 31.2843 83.7969 30.7506 84.0462 30.0952C84.2955 29.4398 84.2819 28.7134 84.0082 28.0678L73.9073 4.24985C73.7642 3.91248 73.5544 3.60753 73.2905 3.35333C73.0265 3.09912 72.7139 2.90092 72.3714 2.77064C72.0289 2.64036 71.6636 2.58069 71.2974 2.59522C70.9312 2.60974 70.5718 2.69817 70.2407 2.85517L68.2947 3.77791C67.9636 3.93491 67.6676 4.15724 67.4247 4.43154C67.1817 4.70584 66.9967 5.02645 66.8808 5.37408C66.7648 5.72171 66.7204 6.08918 66.7502 6.45442C66.7799 6.81965 66.8832 7.1751 67.0539 7.49939L79.1006 30.3944C79.4271 31.015 79.9809 31.4854 80.6462 31.7072C81.3114 31.929 82.0367 31.8851 82.6703 31.5847Z",
    fill: "#1E5EFF",
    "data-sentry-element": "path",
    "data-sentry-source-file": "ProductsNotFound.jsx"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3338 29.2757C95.7924 29.243 96.2206 29.0344 96.529 28.6934C96.8374 28.3525 97.0021 27.9055 96.9887 27.446L96.4898 10.4897C96.4827 10.2496 96.4271 10.0133 96.3264 9.79513C96.2257 9.57697 96.0819 9.38143 95.9037 9.22027C95.7255 9.0591 95.5165 8.93563 95.2894 8.85729C95.0622 8.77894 94.8216 8.74734 94.5819 8.76437L93.1731 8.86475C92.9335 8.88181 92.6998 8.94713 92.4861 9.05678C92.2724 9.16644 92.0831 9.31817 91.9295 9.50285C91.7759 9.68754 91.6612 9.90137 91.5924 10.1315C91.5235 10.3616 91.5019 10.6033 91.5288 10.842L93.4366 27.698C93.4881 28.155 93.7144 28.5743 94.068 28.8683C94.4216 29.1623 94.8751 29.3083 95.3338 29.2757Z",
    fill: "#1E5EFF",
    "data-sentry-element": "path",
    "data-sentry-source-file": "ProductsNotFound.jsx"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.11 35.5438C106.372 36.2731 108.142 35.6039 109.125 34.0265L126.564 6.01909C127.605 4.34595 127.359 2.30671 126.021 1.53321L124.156 0.455212C122.818 -0.318428 120.927 0.48489 119.997 2.22243L104.423 31.3077C103.546 32.9458 103.849 34.8144 105.11 35.5438Z",
    fill: "#1E5EFF",
    "data-sentry-element": "path",
    "data-sentry-source-file": "ProductsNotFound.jsx"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.05a0855b3b77bbe2d65b2dc59194e61d.svg";
export { ForwardRef as ReactComponent };